// https://www.nngroup.com/articles/response-times-3-important-limits/
export const MAGIC_REASONABLE_UI_RESPONSE_TIME_FOR_HUMAN = 100;

// https://www.telerik.com/blogs/what-exactly-is.....-the-300ms-click-delay
export const MAGIC_INTENTIONAL_UI_ACTION_TIME_FOR_HUMAN = 300;
